//============================================================================
// Name        : store_modal.ts
// Purpose     : Adjustment Requests - the store's request popup, loaded into
//               Item Details by AJAX (adjustment_requests/new.js.erb), so its
//               events are bound once on the document
// Author      : Senitron Team
// Copyright   : Copyright 2026 Senitron Corporation. All rights reserved.
//============================================================================
import { toast } from "../tenant_admin/adjustment_requests/common";

declare var $: any;

const MODAL = "#adjustment-request-modal";

export function LoadPage(): void {
  $(document)
    // "Found in" is required only for the tag type it names (a found tag).
    .on("change", "#adjustment-request-form input[name='adjustment_request[tag_type]']", (event: any) => {
      const zone = $("#adjustment_request_found_in_sub_zone_id");
      const required = event.target.value === zone.data("required-for");
      zone.prop("required", required);
      $("#ar-found-in-required").toggleClass("hidden", !required);
      $("#ar-found-in-optional").toggleClass("hidden", required);
      // A re-ticket never changes the EOS: show its own "What this will do".
      const retag = event.target.value === "retag";
      $("#ar-verdict-normal").toggleClass("hidden", retag);
      $("#ar-verdict-retag").toggleClass("hidden", !retag);
    })
    .on("submit", "#adjustment-request-form", () => {
      $("#adjustment-request-errors").addClass("hidden");
      $("#adjustment-request-submit").prop("disabled", true);
    })
    // A server error or lost connection returns no script of ours: say so and
    // let the user try again (C-49).
    .on("ajax:error", "#adjustment-request-form", () => {
      const errors = $("#adjustment-request-errors");
      errors.text(errors.data("send-failed")).removeClass("hidden");
      $("#adjustment-request-submit").prop("disabled", false);
    })
    // Saved (create.js.erb): say what happened in the popup and as a toast; the
    // page reloads when the popup is closed, so Item Details shows the new status.
    .on("ar:submitted", MODAL, (_event: any, message: string) => {
      const modal = $(MODAL);
      modal.find("#adjustment-request-fields, #adjustment-request-errors").addClass("hidden");
      modal.find("#adjustment-request-done").text(message).removeClass("hidden");
      // The buttons sit in wrappers: .sn-btn forces display: inline-block !important.
      modal.find("#adjustment-request-actions").addClass("hidden");
      modal.find("#adjustment-request-close-wrap").removeClass("hidden");
      modal.find("#adjustment-request-close").trigger("focus");
      modal.one("hidden.bs.modal", () => window.location.reload());
      toast(message, true);
    });
}
